import React, { FC, useState } from "react";
import { Bounce, toast } from 'react-toastify';
import IconHoverButton from "../IconHoverButton/IconHoverButton";
import parse from "html-react-parser";
import { ISkill } from "../../model/Skill.model";
import { ISkillDetail } from "../../model/SkillDetail.model";
import { ISkillLevel } from "../../model/SkillLevel.model";
import { IEmployeeProgression } from "../../model/EmployeeProgression.model";
import { useMsal } from "@azure/msal-react";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { protectedResources } from "../../authConfig";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "./EmployeeProgressionOptions.scss";
import Modal from "../Modal/Modal";


interface DesktopSkillGridProps {
  source: string;
  progression: IEmployeeProgression | undefined;
  skill: ISkill;
  skillLevels: Array<ISkillLevel>;
  isManager: boolean;
  bookmarkRemoved(bookmark: IEmployeeProgression): void;
  bookmarkAdded(bookmark: IEmployeeProgression): void;
}

const EmployeeProgressionOptions: FC<DesktopSkillGridProps> = ({
  source,
  progression,
  skill,
  skillLevels,
  isManager,
  bookmarkRemoved,
  bookmarkAdded
}) => {
  const { register, handleSubmit, reset } = useForm();
  const { instance } = useMsal();
  const [account, setAccount] = useState(instance.getActiveAccount());
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.read,
  });
  const [currentProgression, setCurrentProgression] = useState<IEmployeeProgression | undefined>(progression);
  const [deletedProg, setDeletedProg] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [callErr, setErr] = useState(null);
  const navigation = useNavigate();
  if (!currentProgression && progression) {
    setCurrentProgression(progression);
  }
  const addHandleBookmarkClick = () => {
    if (!currentProgression) {
      if (loading) return;//double click block
      setLoading(true);
      let progression: IEmployeeProgression = {
        employeeProgressionId: "",
        skillId: skill.SkillId,
        stage: "B",
        userPrincipalName: account?.username + "",
        createdDate: "",
        CreatedBy: "",
        lastModifiedDate: "",
        lastModifiedBy: "",
      };
      execute(
        "POST",
        `/api/EmpProg/addEmpProg`,
        progression as any
      )
        .then((response) => {
          if (response.error) {
            return;
          }
          setDeletedProg(false);
          setCurrentProgression(response);
          bookmarkAdded(response);
          setLoading(false);
        })
        .catch((err) => {
          setErr(err);
          setLoading(false);
        });
    } else {
      navigation('/bookmarks');
    }
  };
  const removeBookmarkClick = () => {
    setShowDeleteModal(true);
  }
  const removeBookmark = () => {
    setShowDeleteModal(false);
    if (currentProgression) {
      execute(
        "DELETE",
        `/api/EmpProg/deleteEmpProg/${currentProgression.employeeProgressionId}`,
        undefined
      )
        .then((response) => {
          if (response.error) {
            return;
          }
          let cp = currentProgression;
          setDeletedProg(true);
          setCurrentProgression(undefined);
          progression = undefined;
          setLoading(false);
          bookmarkRemoved(cp);
        })
        .catch((err) => {
          setErr(err);
          setLoading(false);
        });
    }
  }
  const viewBookmarksClick = () => {
    navigation('/bookmarks');
  }
  const handleStageChange = (event: any) => {
    let newstage = event.currentTarget.value;
    if (!currentProgression) return;
    currentProgression.stage = newstage;
    if (currentProgression.stage==="M") {
      toast.success('Great Job! Your manager will be notified to discuss your skill(s) accomplishments.');
    }
    execute(
      "PUT",
      `/api/EmpProg/updateEmpProg`,
      currentProgression as any
    )
      .then((response) => {
        if (response.error) {
          return;
        }
        setCurrentProgression(response);
        setLoading(false);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  }

  const HandleSetProgState = (newstage: string) => {
    if (!currentProgression) return;
    currentProgression.stage = newstage;
    execute(
      "PUT",
      `/api/EmpProg/updateEmpProg`,
      currentProgression as any
    )
      .then((response) => {
        if (response.error) {
          return;
        }
        setCurrentProgression(response);
        setLoading(false);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  }

  const getOptions = () => {
    if (isManager) {
      if (!currentProgression) return <><p><b>Employee Status: <br />Not Bookmarked</b></p></>

      return <><p><b>Employee Status: <br />Bookmarked</b></p></>
    }
    if (currentProgression === undefined) {
      return (

        <IconHoverButton
          isLink={false}
          linkURL={null}
          buttonClassName="gap--25 p--50 bdr-radius--25 bg-white no-border employee-progression-icon-hover-button squared-layout"
          buttonClassHoverName="bg-primary-important"
          iconClassName="icon-primary bookmark-icons"
          buttonOnClick={addHandleBookmarkClick}
          iconHoverClassName="icon-white bookmark-icons"
          iconName="icon-bookmark-skill"
          iconHoverName="icon-bookmark-skill"
          buttonText="Bookmark Skill"
          buttonTextClassName="clr-primary fnt-wght-500"
          buttonTextHoverClassName="clr-white"
        />
      );
      /*} else if (currentProgression !== undefined && source!=='progression') {
        return (
          <IconHoverButton
            isLink={false}
            linkURL={null}
            buttonClassName="m-t--75 gap--25 p--50 bdr-radius--25"
            buttonClassHoverName="bg-primary"
            iconClassName="icon-primary bookmark-icons"
            buttonOnClick={viewBookmarksClick}
            iconHoverClassName="icon-white bookmark-icons"
            iconName="icon-bookmarked-skill"
            iconHoverName="icon-bookmarked-skill"
            buttonText="View Bookmarks"
            buttonTextClassName="wht-spc-no-wrap clr-primary fnt-wght-500"
            buttonTextHoverClassName="clr-white"
          />
        );*/
    } else {
      return <>



        <IconHoverButton
          isLink={false}
          linkURL={null}
          buttonClassName="m-t--75 gap--25 p--50 bdr-radius--25 bg-white no-border employee-progression-icon-hover-button squared-layout"
          buttonClassHoverName="bg-primary-important"
          iconClassName="icon-primary bookmark-icons"
          buttonOnClick={removeBookmarkClick}
          iconHoverClassName="icon-white bookmark-icons"
          iconName="icon-trash"
          iconHoverName="icon-trash"
          buttonText="Remove Bookmark"
          buttonTextClassName="clr-primary fnt-wght-500"
          buttonTextHoverClassName="clr-white"
        />

        <Modal isOpen={showDeleteModal} modalTitle="Delete Bookmark" onClose={() => { setShowDeleteModal(false) }}>
          <>
            <div className="modal-form-content-scroll-container">
              <div>Are you sure you want to delete this bookmark?</div>
            </div>
            <div className="modal-form-button-container two-button">
              <button className="btn-med-gray" onClick={e => setShowDeleteModal(false)}>No</button>
              <button className="btn-secondary" onClick={e => removeBookmark()}>Yes</button>
          </div>
        </>
      </Modal >
      </>;
    }
  };

return <>{getOptions()}</>;
};

export default EmployeeProgressionOptions;
